module.exports = __webpack_public_path__ + "img/img_success.b466a436.svg";